import {
  IImage,
  IImageData,
  Category
} from '../abstract'
import {
  IType,
  ITypeData,
  IAccommodation,
  IAccommodationData,
  ITaste,
  ITasteData,
  IBudget,
  IBudgetData,
  ILocation,
  ILocationData,
  IStep,
  IStepData,
  ITag,
  ISeason,
  ISeasonData
} from './index'
import {
  ICustomer,
  ICustomerData
} from '../index';
import { TravelFormat } from '../abstract/travelFormat.model';
import { ITravelAdditions } from './additions/travelAdditions';


export type Mark = 'new' | 'hit'

export interface ITravelBaseData {
  readonly id?: number
  name?: string
  price?: number | string
}

interface ITravelShortData extends ITravelBaseData {
  mark?: Mark
  readonly general_image: IImageData
}

interface ITravelCriteriaCommonData {
  tourist_max?: number
  tourist_min?: number
}

interface ITravelFilterChoiceData {
  accommodation?: string[]
  travel_type?: string[]
  taste?: string[]
  locations?: string[]
  season?: string[]
}

interface ITravelCriteriaChoiceAdditionalData {
  category?: Category[];
  travel_format?: TravelFormat[];
}


interface ITravelLimitsBase {
  tourist_max?: number
  budget_max?: number
  duration_days_max?: number
}

export interface ITravelLimits extends ITravelLimitsBase {
  price_max?: number
}

interface ITravelFilterNumericBaseData extends ITravelLimitsBase, ITravelCriteriaCommonData {
  budget_min?: number
  duration_days_min?: number
}

interface ITravelFilterNumericData extends ITravelFilterNumericBaseData, ITravelLimits {
  price_min?: number
}


export interface ITravelFilterData extends ITravelFilterChoiceData, ITravelCriteriaChoiceAdditionalData, ITravelFilterNumericData {
  search?: string
}

interface ITravelFilterIdsBaseData {
  accommodation?: number[]
  travel_type?: number[]
  taste?: number[]
  locations?: number[]
  season?: number[]
}

export interface ITravelFilterIdsData extends ITravelFilterNumericData, ITravelFilterIdsBaseData {
}

export interface ITravelInfoIdsData extends ITravelFilterNumericBaseData, ITravelFilterIdsBaseData {
}

export interface ITravelFilterIdsExtendedData extends ITravelFilterIdsData, ITravelCriteriaChoiceAdditionalData {
}

export interface ITravelInfoIdsExtendedData extends ITravelInfoIdsData {
  description?: string
}

export interface ITravelInfoIdsExtended extends ITravelInfoIdsExtendedData {
  validate(): boolean
  update(data?: ITravelInfoIdsExtendedData): void
}

export interface ITravelFilterDataExtended extends ITravelFilterData {
  page?: number
  page_size?: number
  ordering?: string
}

export interface ITravelCriteriaChoiceData {
  accommodation?: IAccommodationData[]
  travel_type?: ITypeData[]
  taste?: ITasteData[]
  locations?: ILocationData[]
  season?: ISeasonData[]
}

export interface ITravelCriteriaData extends ITravelCriteriaCommonData, ITravelCriteriaChoiceData {
  readonly duration_days?: number
}

export interface ITravelCriteriaFullData extends ITravelCriteriaChoiceAdditionalData, ITravelCriteriaChoiceData {
}

export interface ITravelData extends ITravelShortData, ITravelCriteriaData {
  readonly description?: string;
  readonly images?: IImageData[];
  readonly budgets?: IBudgetData[];
  readonly category?: Category;
  readonly travel_format?: TravelFormat;
  readonly travel_additions?: ITravelAdditions;

  readonly steps?: IStepData[];
}

export interface ITravelCriteriaCommon extends ITravelCriteriaCommonData {
  duration_days?: number
  tourist_min: number
}

export interface ITravelCriteriaChoice {
  accommodation?: IAccommodation[]
  travel_type?: IType[]
  taste?: ITaste[]
  locations?: ILocation[]
  season?: ISeason[]
}

export interface ITravelCriteria extends ITravelCriteriaCommon, ITravelCriteriaChoice {
  budgets?: IBudget[]
}

export interface ITravelCriteriaFull extends ITravelCriteriaChoice, ITravelCriteriaChoiceAdditionalData {
  reset(): void
}

export interface ITravelExtendData extends ITravelData {
  readonly customer?: ICustomerData
}

export interface ITravelBase extends ITravelBaseData {
  price: number
  validate(): boolean
  update(data?: ITravelBaseData): void
}


export interface ITravel extends ITravelShortData, ITravelCriteria {
  description?: string;
  category?: Category;
  travel_format?: TravelFormat;
  travel_additions?: ITravelAdditions;
  price: number | string;

  general_image: IImage;
  images?: IImage[];

  steps?: IStep[];

  tags?: ITag[];

  readonly customer?: ICustomer;

  validate(): boolean;
  update(data?: ITravelExtendData): void;
  shortDescription(): string;
}

export interface ITravelFilter extends ITravelFilterData {
  reset(): void
}

export interface ITravelByCategory {
  readonly category?: Category;
  readonly travelFormat: TravelFormat;
  travels?: ITravel[] | undefined;
}

export const TRAVEL_NAME_MAX_LENGTH = 100;
export const TRAVEL_DESCRIPTION_MAX_LENGTH = 1000;
export const TRAVEL_SHORT_DESCRIPTION_MAX_LENGTH = 500;
